import FullPageLoader from '@src/common/FullPageLoader';
import React, { useState,useRef,useEffect } from 'react';
import Modal from "../../common/ModalPopup";
import {saveRemittancePayment,assignLead} from '../../../src/store/slices/remittance';
import { useParams } from "react-router-dom";
import ReactSelect from "react-select";
import {LEAD_REMITTANCE_STATUS_MARK,LEAD_ASSIGN_TO,COUNTRY_CODE,APP_COUNTRY} from '../../config/constant'
import { useLanguage } from "../../../src/context/LanguageContext";
import { allowAlphaNumericKeys } from '@src/config/helper';
import { toast } from "react-toastify";




const PaymentInfoPopup: React.FC<any> = ({ viewPaymentInfo, handleViewPaymentInfo,from,remittanceType,reloadDetail,selectedLeads,statusMark,message,setConfirmationMessage,paymentData,onRequestConfirm ,callUpdateFunction,setCallUpdateFunction}) => {
    const {translations} = useLanguage();
    const { id } = useParams<{ id: string }>()
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState<any>({});
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [formErrors, setFormErrors] = useState<any>({});
    const [remittanceStatus, setRemittanceStatus] = useState<number>(0);

    useEffect(()=>{
        if(statusMark && statusMark.length > 0){
            setRemittanceStatus(+statusMark[0].value);
        }
    }, [statusMark])

    const handleChange = (selectedValue: any, key: string) => {
        let value: any;
        if (selectedValue.target.type === "file") {
            // File input: store the first file
            const files = (selectedValue.target as HTMLInputElement).files;
            value = files && files.length > 0 ? files[0] : null;
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        } else {
            // Text / textarea inputs
            value = selectedValue.target.value;
        }
        setFormData((prev: any) => ({
            ...prev,
            [key]: value,
        }));
        setFormErrors((prev: any) => {
            const updatedErrors = { ...prev };
            delete updatedErrors[key];
            return updatedErrors;
        });
    }

    const handleRemoveFile = (key: string) => {
        setFormData((prev: any) => ({
            ...prev,
            [key]: null,
        }));
        setFormErrors((prev: any) => {
            const updatedErrors = { ...prev };
            delete updatedErrors[key];
            return updatedErrors;
        });
    };

    // Validate form data
    const validateForm = (): boolean => {
        let errors: any = {};
        // const requiredPaymentFields = [
        //     "amount",
        // ];
        // const paymentFieldLabels: Record<string, string> = {
        //     amount: "Amount To Be Disbursed"
        // };
        // const missingPaymentFields = requiredPaymentFields.filter((key) => {
        //     const value = paymentData?.[key];
        //     return value === null || value === undefined || value === "";
        // });
        // if (missingPaymentFields.length > 0) {
        //     missingPaymentFields.forEach((key) => {
        //         const label = paymentFieldLabels[key] || key;
        //         toast.error(`${label} is required.`);
        //     });
        // }
        if(from === "RemittanceList" && remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['MAKE_PAYMENT']){
            //TC ID (Required)
            if (!formData.batch_no) {
                errors.batch_no = "Batch No. is required.";
            }
        }
        //TC ID (Required)
        if (!formData.tc_id) {
            errors.tc_id = "TC ID is required.";
        }
        //Upload Photo (mandatory, 1 file only, must be image/pdf)
        if (!formData.payment_proof) {
            errors.payment_proof = "Upload photo is required.";
        } else if (
            formData.payment_proof &&
            !["image/png", "image/jpeg", "application/pdf"].includes(formData.payment_proof.type)
        ) {
            errors.payment_proof = "Only PNG, JPG, or PDF files are allowed.";
        }
        setFormErrors(errors);
        // return true if no errors
        return Object.keys(errors).length === 0;
    };

    const handleUpdate = async () => {
        let isFormValid = validateForm();
        if(remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['BACK_TO_OPS']){
            isFormValid = true;
        }
        if(isFormValid){
            try{
                setLoading(true);
                if(remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['BACK_TO_OPS']){
                    let payload:any = {
                        lead_assign_to : LEAD_ASSIGN_TO['REM_OPS'],
                        remarks:formData.remarks
                    }
                    if(selectedLeads && selectedLeads.length > 0){
                        payload.bulk_update_leads = selectedLeads.map(({ remittance_status,remittance_type_id, ...rest }:any) => rest);
                        payload.is_bulk_update = 1;
                    }
                    const response:any = await assignLead(payload);
                    if (response?.status === 200) {
                        setFormData({});
                        setFormErrors({});
                        reloadDetail();
                        handleViewPaymentInfo(false);
                    }
                }else{
                    const data:any = new FormData();
                    if(id){
                        data.append("lead_id", id);
                    }
                    if(remittanceType){
                        data.append("remittance_type",remittanceType)
                    }
                    if(formData.batch_no){
                        data.append("batch_no", formData.batch_no);
                    }
                    data.append("tc_id", formData.tc_id);
                    if(formData.remarks){
                        data.append("remarks", formData.remarks);
                    }
                    if (formData.payment_proof) {
                        data.append("payment_proof", formData.payment_proof);
                    }
                    // if (paymentData) {
                    //     Object.entries(paymentData).forEach(([key, value]) => {
                    //         if (value !== undefined && value !== null) {
                    //             data.append(key, String(value));
                    //         }
                    //     });
                    // }
                    if(selectedLeads && selectedLeads.length > 0){
                        data.append("bulk_update_leads",JSON.stringify(selectedLeads.map(({ remittance_status,remittance_type_id, ...rest }: any) => rest)));
                        data.append("is_bulk_update",true);
                    }
                    const response:any = await saveRemittancePayment(data);
                    if (response?.status === 200) {
                        setFormData({});
                        setFormErrors({});
                        reloadDetail();
                        handleViewPaymentInfo(false);
                    }else{
                        setCallUpdateFunction(false);
                    }
                }
            }catch (error) {
                console.error("Error while save Remittance Payment:", error);
            }finally {
                setLoading(false);
            }
        }
    }

    const handleStatusChange = (value: number) => {
        if(value === LEAD_REMITTANCE_STATUS_MARK['BACK_TO_OPS']){
            setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"])
        }else if (value === LEAD_REMITTANCE_STATUS_MARK['MAKE_PAYMENT']){
            setConfirmationMessage(translations.Remittance?.["PAYMENT_INFORMATION"])
        }
        setRemittanceStatus(value);
    }

    useEffect(() => {
        if (!callUpdateFunction) return;
        const runUpdate = async () => {
            await handleUpdate();
        };
        runUpdate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callUpdateFunction]);

    return (
        <div className="view-timeline-popup image-timeline-popup">
            <FullPageLoader show={loading} />
            <Modal show={viewPaymentInfo} handleClose={() => handleViewPaymentInfo(false)} from={from}>
                <div className="modal-header">
                    <h2>{message || "Payment Information"}</h2>
                </div>
                <div className="modal-body" >
                    <div className="row">
                        {
                            statusMark && statusMark.length > 0 &&
                            <div className="col-md-12">
                                <ReactSelect
                                    options={statusMark}
                                    onChange={(e: any) => handleStatusChange(e.value)}
                                    value={statusMark.find((x: any) => x.value === remittanceStatus)}
                                    placeholder="Remittance Status"
                                />
                            <br></br>
                            </div>
                        }
                        {
                            from === "RemittanceList" && remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['MAKE_PAYMENT'] &&
                            <>
                                <div className="col-md-12">
                                    <fieldset className="">
                                        <label>{translations.Remittance?.["BATCH_NO"]}*</label>
                                        <div className="material">
                                            <input type="text" 
                                            // placeholder="Batch No." 
                                            name="batch_no" 
                                            className="form-input" 
                                            value={formData.batch_no || ""} 
                                            onChange={(e) => handleChange(e, "batch_no")}
                                            onKeyDown={(e) => allowAlphaNumericKeys(e)}
                                            />
                                        </div>
                                        {formErrors.batch_no && (
                                            <small className="error">{formErrors.batch_no}</small>
                                        )}
                                    </fieldset>
                                </div>
                                <div className="col-md-12">
                                    <fieldset className="">
                                        <div className="material">
                                            <label>{translations.Remittance?.["TCP_ID"]}</label>
                                            <input type="text" 
                                            // placeholder="TC ID" 
                                            name="tc_id" 
                                            className="form-input" 
                                            value={formData.tc_id || ""} 
                                            onChange={(e) => handleChange(e, "tc_id")}
                                            onKeyDown={(e) => allowAlphaNumericKeys(e)}

                                            />
                                        </div>
                                        {formErrors.tc_id && (
                                            <small className="error">{formErrors.tc_id}</small>
                                        )}
                                    </fieldset>
                                </div>

                                <div className="col-md-12">
                                    <div className="attech-repair-doc payment-info-upload">
                                        <div className="upload-text">
                                            <i className="ic-attach_file"></i>
                                            <input type="file" name="payment_proof" ref={fileInputRef} onChange={(e) => handleChange(e, "payment_proof")}/>
                                            <p>{translations.Remittance?.["UPLOAD_PHOTO"]}</p>
                                        </div>
                                        {formData.payment_proof && (
                                            <div className="uploaded-file">
                                                <div className="upload-file-name">
                                                    <a href={URL.createObjectURL(formData.payment_proof)} target="_blank" rel="noopener noreferrer">
                                                        {formData.payment_proof.name}
                                                    </a>
                                                </div>
                                                <span className="remove-icon" onClick={() => handleRemoveFile("payment_proof")}>✕</span>
                                            </div>
                                        )}
                                    </div>
                                    {formErrors.payment_proof && (
                                        <small className="error">{formErrors.payment_proof}</small>
                                    )}
                                </div>
                            </>
                        }

                        {
                            from === "InsurerPartnerRemittance"&&
                            <>
                                <div className="col-md-12">
                                    <fieldset className="">
                                        <div className="material">
                                            <label>{translations.Remittance?.["BATCH_NO"]}</label>
                                            <input type="text" 
                                            // placeholder="Batch No." 
                                            name="batch_no" 
                                            className="form-input" 
                                            value={formData.batch_no || ""} 
                                            onChange={(e) => handleChange(e, "batch_no")}
                                            onKeyDown={(e) => allowAlphaNumericKeys(e)}
                                            />
                                        </div>
                                        {formErrors.batch_no && (
                                            <small className="error">{formErrors.batch_no}</small>
                                        )}
                                    </fieldset>
                                </div>
                                <div className="col-md-12">
                                    <fieldset className="">
                                        <div className="material">
                                            <label>{translations.Remittance?.["TCP_ID"]}</label>
                                            <input type="text" 
                                            // placeholder="TC ID" 
                                            name="tc_id" 
                                            className="form-input" 
                                            value={formData.tc_id || ""} onChange={(e) => handleChange(e, "tc_id")}
                                            onKeyDown={(e) => allowAlphaNumericKeys(e)}
                                            />
                                        </div>
                                        {formErrors.tc_id && (
                                            <small className="error">{formErrors.tc_id}</small>
                                        )}
                                    </fieldset>
                                </div>

                                <div className="col-md-12">
                                    <div className="attech-repair-doc payment-info-upload">
                                        <div className="upload-text">
                                            <i className="ic-attach_file"></i>
                                            <input type="file" name="payment_proof" ref={fileInputRef} onChange={(e) => handleChange(e, "payment_proof")}/>
                                            <p>{translations.Remittance?.["UPLOAD_PHOTO"]}</p>
                                        </div>
                                        {formData.payment_proof && (
                                            <div className="uploaded-file">
                                                <div className="upload-file-name">
                                                    <a href={URL.createObjectURL(formData.payment_proof)} target="_blank" rel="noopener noreferrer">
                                                        {formData.payment_proof.name}
                                                    </a>
                                                </div>
                                                <span className="remove-icon" onClick={() => handleRemoveFile("payment_proof")}>✕</span>
                                            </div>
                                        )}
                                    </div>
                                    {formErrors.payment_proof && (
                                        <small className="error">{formErrors.payment_proof}</small>
                                    )}
                                </div>
                            </>
                        }

                        <div className="col-md-12">
                            <fieldset className="">
                                <div className="material">
                                    <textarea id="comments" rows={5} placeholder=" " name="remarks" className="form-input textarea-height" value={formData.remarks || ""} onChange={(e) => handleChange(e, "remarks")} />
                                    <label data-label='Remarks' className="form-label"></label>
                                </div>
                                 {formErrors.remarks && (
                                    <small className="error">{formErrors.remarks}</small>
                                )}
                            </fieldset>
                        </div>

                        {
                            from === "RemittanceList" && remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['MAKE_PAYMENT'] &&
                                <div className="col-md-12">
                                    <button className="btn-primary m-md-t" onClick={() => COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH ? handleUpdate() : onRequestConfirm()}>Update</button>
                                </div>
                        }
                        {
                            from === "RemittanceList" && remittanceStatus === LEAD_REMITTANCE_STATUS_MARK['BACK_TO_OPS'] &&
                            <div className="col-md-12">
                                <button className="btn btn-primary btn-lg m-sm-r" style={{ minWidth: "107px" }} onClick={() => handleUpdate()}>Yes</button>
                                <button className="btn btn-line" onClick={() => handleViewPaymentInfo(false)}>NO</button>
                            </div>
                        }

                        {
                            from === "InsurerPartnerRemittance" &&
                            <div className="col-md-12">
                                { COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH ?
                                    <button className="btn-primary m-md-t" onClick={() => handleUpdate()}>Update</button>
                                    :
                                    <button className="btn-primary m-md-t" onClick={() => onRequestConfirm()}>Update</button>
                                }
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default PaymentInfoPopup;